
riot.tag2('import-persons-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Импорт</div>\n    </yield>\n    <yield to="body">\n      <loader text="Импорт" indeterminate="true" if="{loader}"></loader>\n      <form onchange="{change}" onkeyup="{change}">\n        <div class="form-group {has-error: error.filename}">\n          <div class="input-group">\n            <div class="input-group-btn">\n              <div class="btn-file btn btn-default" onchange="{changeFile}">\n                <input name="file" type="file" accept=".xlsx, .csv"><i class="fa fa-fw fa-folder-open text-primary"></i>\n              </div>\n            </div>\n            <input class="form-control" name="filename" value="{item.filename}" placeholder="Выберите файл или введите ссылку" __disabled="{file.files.length}">\n            <div class="input-group-btn">\n              <div class="btn-file btn btn-default" onclick="{clear}" title="Сброс"><i class="fa fa-fw fa-close text-danger"></i></div>\n            </div>\n          </div>\n        </div>\n        <div class="row">\n          <div class="col-md-6 col-xs-12">\n            <div class="form-group">\n              <label class="control-label">Пропустить строк</label>\n              <input class="form-control" name="skip" min="0" step="1" value="{item.skip}" type="{\'number\'}">\n            </div>\n            <div class="form-group">\n              <label class="control-label">Ограничитель поля</label>\n              <input class="form-control" id="limFId" name="limiterField" value="{item.limiterField}">\n            </div>\n          </div>\n          <div class="col-md-6 col-xs-12">\n            <div class="form-group">\n              <label class="control-label">Разделитель столбцов</label>\n              <select class="form-control" id="delimId" name="delimiter" value="{item.delimiter}">\n                <option each="{i in delimiters}" value="{i.name}" __selected="{i.name == parent.item.delimiter}" no-reorder>{i.title}</option>\n              </select>\n            </div>\n          </div>\n          <div class="help-block">{error.filename}</div>\n        </div>\n\n\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button" __disabled="{cannotBeClosed}">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" id="startImp" onclick="{parent.submit}" type="button" __disabled="{cannotBeClosed}">Импорт</button>\n    </yield>\n  </bs-modal>\n', '', '', function(opts) {
'use strict';

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var self = this;
self.loader = true;

self.on('mount', function () {
    var modal = self.tags['bs-modal'];

    /** ... разделителителя столбцов **/
    modal.delimiters = [{ name: 'auto', title: 'Автоопределение' }, { name: ';', title: 'Точка с запятой' }, { name: ',', title: 'Запятая' }, { name: '\t', title: 'Табуляция' }];

    /** ... ключевое поле */
    modal.keyFields = [{ name: 'article', title: 'Артикул' }, { name: 'id', title: 'Идентификатор' }, { name: 'code', title: 'Код (URL)' }, { name: 'name', title: 'Наименование' }];

    /** значния по умолчанию */
    modal.error = false;
    modal.mixin('validation');
    modal.mixin('change');
    var limiterFieldValue = '"';
    var skipValue = 1;

    modal.item = {
        filename: '',
        type: '0',
        reset: false,
        limiterField: limiterFieldValue,
        skip: skipValue,
        delimiter: modal.delimiters[0]['name']
    };

    modal.rules = {
        filename: {
            required: true,
            rules: [{
                type: 'url',
                prompt: 'Выберите файл или введите правильную ссылку'
            }]
        }
    };
    self.blockImportButtonReload(modal.item.filename);

    modal.loader = false;
    modal.changeFile = function (e) {
        modal.item.filename = e.target.files[0].name;
        modal.update();

        /** блокировка полей для не CSV */
        if (modal.item.filename.indexOf(".csv") + 1 != 0) {
            document.getElementById("delimId").disabled = false;
            document.getElementById("limFId").disabled = false;
        } else {
            document.getElementById("delimId").disabled = true;
            document.getElementById("limFId").disabled = true;
        }

        self.blockImportButtonReload(modal.item.filename);
    };

    modal.clear = function () {
        modal.item.filename = '';
        modal.item.file = '';
        modal.file.value = '';
        self.blockImportButtonReload(modal.item.filename);
    };

    /** после изменения */
    modal.afterChange = function (e) {
        if (modal.file.files && !modal.file.files.length) {
            var name = e.target.name;
            delete modal.error[name];
            modal.error = (0, _extends3.default)({}, modal.error, modal.validation.validate(modal.item, modal.rules, name));
        }

        if (modal.file.files && modal.file.files.length) modal.error = false;

        if (modal.item && modal.item.type == 0) modal.item.reset = false;

        delete modal.item.file;
    };
});

self.blockImportButtonReload = function (filename) {
    /**
     * блокировка/разб.. кнопки импорта
     * @param {string} filename  имя выбранного файла
     * @param {bool}   startImp  id кнопки импорта
     */
    if (filename == '' || filename == undefined) document.getElementById("startImp").disabled = true;else document.getElementById("startImp").disabled = false;
}; // блокировка/разб.. импорта

self.submit = function () {
    var modal = self.tags['bs-modal'];
    var target = modal.file;
    modal.loader = true;

    /**
     * ЗАГРУЗИТЬ
     * данные уходят в Product.php post
     * по файлу - $items, по настройкам - $_POST
     */

    /** прикрепляем к отправке параметры */
    var formData = new FormData();
    for (var i = 0; i < target.files.length; i++) {
        formData.append('file' + i, target.files[i], target.files[i].name);
    }
    formData.append('delimiter', modal.item.delimiter);
    formData.append('limiterField', modal.item.limiterField);
    formData.append('skip', parseInt(modal.item.skip));
    API.upload({
        object: 'Contact',
        data: formData,
        success: function success(response) {
            self.update();
            observable.trigger('persons-reload');
            modal.modalHide();
        }
    });
    $("#importFile").val(undefined);
};
});


// WEBPACK FOOTER //
// ./modals/import-persons-modal.tag